import React from 'react';

import styles from './NewSizeGuideTable.module.scss';
import clsx from 'clsx';
import { useNewSizeGuideContext } from './context/useNewSizeGuideContext';
import Button from '../../atoms/button';
import randomID from '../../../utils/randomID';

const formatListItem = (listItem, measure) => {
  const result = { head: [], rows: [] };

  listItem.forEach((item, index) => {
    result?.head?.push({
      name: `${item.itemName} ${
        item?.shouldConvert ? `(${measure === 'cm' ? 'cm' : 'inches'})` : ''
      }`,
      shouldConvert: item?.shouldConvert,
    });

    item.values.forEach((value, valueIndex) => {
      if (index === 0) {
        result?.rows?.push([]);
      }
      if (!item?.shouldConvert) {
        result.rows[valueIndex].push({
          name: value.name || '-'
        });
        return;
      }

      let roundedValue;
      if (measure === 'cm') {
        roundedValue = Math.round(Number(value.name) * 10) / 10;
      } else {
        let inch = value.name / 2.54;
        roundedValue = Math.round(inch * 10) / 10;
      }

      return result?.rows?.[valueIndex]?.push({
        name: roundedValue || '-'
      });
    });
  });

  return result;
}

export const NewSizeGuideTable = ({ table: { lineItems } }) => {
  const { activeRow, setActiveRow, sizeFormat, setSizeFormat, getNumber } = useNewSizeGuideContext();
  const list = formatListItem(lineItems, sizeFormat);

  return (
    <div style={{
      '--table-column-count': lineItems?.length,
    }}>
      <div className={styles.convertButtons}>
        <Button
          onClick={() => setSizeFormat('cm')}
          className={clsx(styles.button, { [styles.activeBtn]: sizeFormat === 'cm' })}
          as="text"
          size="medium"
        >
          cm
        </Button>
        <Button
          onClick={() => setSizeFormat('inch')}
          className={clsx(styles.button, { [styles.activeBtn]: sizeFormat === 'inch' })}
          as="text"
          size="medium"
        >
          inches
        </Button>
      </div>
      <div className={styles.table}>
        <div className={styles.tableHead}>
        {list.head.map((head, key) => (
          <div key={`head_${key}`} className={clsx(styles.tableItem, styles.tableTitle)}>
            {head.name}
          </div>
        ))}
        </div>
        <div className={styles.tableContent}>
          {list.rows.map((row, key) => (
            <div
              key={`itemRow_${key}`}
              onClick={() => setActiveRow(getNumber(row?.[0]?.name))}
              className={clsx(styles.itemRow, { [styles.activeRow]: activeRow === getNumber(row?.[0]?.name) })}
            >
              {row.map((item) => (
                <div key={randomID(`item_${key}_${item.name}`)} className={styles.tableItem}>{item.name}</div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

